// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"f596644f","132":"9d2f8c9c","271":"b86ecd77","279":"79a71c71","728":"5169ad70","748":"84e08b5a","798":"39ff711c","897":"d686be12"}[chunkId] + ".chunk.css";
};